module.exports = __webpack_public_path__ + "static/media/project-thumbnail02.93630639.jpg";